const pl = {
  generic: {
    version: 'Wersja',
    error: 'Błąd',
    ups: 'Ups!',
    understand: 'Rozumiem',
    no_options: 'Brak opcji',
    network_error: 'Błąd sieci',
    qraphql_error: 'Błąd GraphQL',
    no: 'Nie',
    maybe_later: 'Może później',
    exit_without_saving: 'Czy na pewno chcesz porzucić zmiany?',
    free: 'Darmowy',
    yes: 'Tak',
    active: 'Aktywna',
    inactive: 'Nieaktywna',
    visible: 'Widoczne',
    invisible: 'Niewidoczne',
    available: 'Dostępne',
    unavailable: 'Niedostępne',
    success_message: 'Zmiany zostały zapisane',
    selected: 'zaznaczonych',
    no_results: 'Brak wyników',
    reservation_created: 'Rezerwacja została utworzona',
    from: 'Od',
    to: 'Do',
    all: 'Wszyscy',
    none: 'BRAK',
    no_data: 'BRAK danych',
    clear: 'Wyczyść',
    clear_date: 'Wyczyść datę',
  },
  btn: {
    log_in: 'Zaloguj się',
    go_to_app: 'Przejdź do aplikacji',
    create_new_password: 'Utwórz nowe hasło',
    confirm: 'Potwierdź',
    save: 'Zapisz',
    cancel: 'Anuluj',
    back: 'Wróć',
    accept: 'Przyjmij',
    reject: 'Odrzuć',
    add_tenant: 'Dodaj najemcę',
    save_tenant: 'Zapisz najemcę',
    add_domain: 'Dodaj domenę',
    delete_domain: 'Usuń domenę',
    send_again: 'Wyślij ponownie zaznaczone',
    delete: 'Usuń',
    delete_selected: 'Usuń zaznaczone',
    send_message: 'Wyślij wiadomość',
    exit: 'Wyjdź',
    add_menu_item: 'Dodaj nowe danie',
    more_data: 'Więcej Danych',
    edit: 'Edytuj',
    add_dish: 'Dodaj danie',
    edit_dish: 'Edytuj danie',
    add_subscriptions_parking: 'Dodaj abonament',
    search: 'szukaj',
    filtr_clear: 'Wyczyść filtr',
    clear_filters: 'Wyczyść filtry',
    expand: 'Rozwiń',
    collapse: 'Zwiń',
    backToUser: 'Wróć do użytkownika',
    add_survey: 'Dodaj Ankietę',
    show_regulation: 'Pokaż treść regulaminu',
    hide_regulation: 'Ukryj treść regulaminu',
    add_comment: 'Dodaj komentarz',
    submit_range: 'Zatwierdź zakres dat',
    save_changes: 'Zapisz zmiany',
    logout: 'Wyloguj',
    download_csv: 'Pobierz CSV',
    show: 'Pokaż',
    check_again: 'Sprawdź ponownie',
    refresh_app: 'Odśwież',
    remind_later: 'Przypomnij później',
    close: 'Zamknij',
  },
  form: {
    password: 'Hasło',
    new_password: 'Nowe hasło',
    email_login: 'Email lub Login',
    field_required: 'Pole wymagane',
    select_tenant: 'Wybierz najemcę...',
    tenant_required: 'Musisz wybrać najemcę aby zaakceptować',
    no_tenants: 'Brak najemców',
    comment: 'Opcjonalny komentarz dla użytkownika',
    company_name: 'Nazwa firmy',
    domain_name: 'Nazwa domeny mailowej',
    login: 'Login',
    contact_email: 'Email kontaktowy',
    work_email: 'Email służbowy',
    first_name: 'Imię',
    last_name: 'Nazwisko',
    full_name: 'Imię i nazwisko',
    search: 'Szukaj',
    message: 'Napisz odpowiedź',
    form_error: 'Wypełnij wymagane pola',
    log_comment: 'Komentarz',
    valid_nip: 'Wprowadź poprawny NIP',
    card_number: 'Numer karty',
    valid_car_plate: 'Wprowadź poprawny numer tablicy rejestracyjnej',
    valid_card_number_length:
      'Numer karty powinien mieć liczbę znaków od {{min}} do {{max}}',
    valid_card_number: 'Numer karty nie może zawierać liter ani spacji',
    valid_card_number_with_comma:
      'Numer karty musi zawierać przecinek lub kropkę',
  },
  days: {
    Monday: 'Pn',
    Tuesday: 'Wt',
    Wednesday: 'Śr',
    Thursday: 'Czw',
    Friday: 'Pt',
    Saturday: 'Sob',
    Sunday: 'Nie',
  },
  admin_menu: {
    language: 'Język',
    garden: 'Garden',
    garden_tickets: 'Bilety do ogrodu',
    gastro: 'Restauracja',
    gastro_menu: 'Menu',
    orders: 'Zamówienia',
    orders_history: 'Historia zamówień',
    parking_areas: 'Parking',
    mobile_access: 'Mobilna karta dostępowa',
    parking_sold_subscription_list: 'Lista sprzedanych abonamentów',
    payment_history: 'Historia płatności',
    parking_subscription_product_list: 'Lista produktów abonamentowych',
    parking_sold_one_time_tickets: 'Lista sprzedanych biletów jednorazowych',
    parking_places: 'Statusy miejsc parkingowych',
    parking_place_reservations: 'Rezerwacje miejsc parkingowych',
    parking_list: 'Lista parkingów',
    users: 'Użytkownicy',
    tenant_issues: 'Prośby o status rezydenta',
    users_list: 'Wszyscy użytkownicy',
    unconfirmed_emails: 'Niepotwierdzone maile',
    companies_list: 'Lista firm',
    messages: 'Wiadomości',
    minimize_menu: 'Zwiń Menu',
    surveys: 'Ankiety',
    surveys_list: 'Lista Ankiet',
    surveys_results_list: 'Ankiety wyniki',
    blocking_olivka_products: 'Blokowanie ofert Olivki',
    bike_lockers: 'Szafki rowerowe',
    lockers_list: 'Lista szafek',
    product_list: 'Lista produktów',
    group_reservation_list: 'Lista rezerwacji grupowych',
    reservation_list: 'Lista rezerwacji',
    locker_statistics: 'Statystyka',
    parking_occupancy_report: 'Raport zajętości parkingów',
    getresponse_sync: 'Synchronizacja',
    email_list: 'Lista użytkowników',
    integrations: 'Integracje',
    reservations: 'Rezerwacje parkingów firmowych',
    data: 'Dane i analityka',
    occupancy_report: 'Miejsca wg budynków',
    parking_pool_data: 'Dane produktu parkingowego',
    hid_data: 'Dane produktu mobilnego dostępu',
    modules: 'Moduły',
    company_reservations: 'Rezerwacje firmowe',
    badge_new: 'NOWE',
    my_solvy: 'My Solvy',
    faq: 'FAQ',
  },
  login_screen: {
    my: 'Moja',
    remind_password: 'Nie pamiętam hasła',
    kicker: 'Dostęp do panelu',
    title: 'Zaloguj się',
    subtitle:
      'Użyj danych logowania My Olivia, aby zarządzać usługami swojej firmy.',
    hero_kicker: 'Olivia Centre',
    hero_title: 'Panel office managera',
    hero_subtitle:
      'Zarządzaj parkingiem, dostępem i użytkownikami swojej firmy w jednym miejscu.',
    feature_parking: 'Parking firmowy i rezerwacje',
    feature_users: 'Użytkownicy i profile usług',
    feature_access: 'Mobilna karta dostępowa',
  },
  maintenance_screen: {
    app_name: 'Office Manager',
    title: 'Trwają prace serwisowe',
    content:
      'Aktualizujemy panel Office Managera. W tym czasie logowanie oraz zarządzanie parkingiem i kartami dostępu są chwilowo niedostępne.',
    nothing_to_do:
      'Nie musisz nic robić — po zakończeniu prac panel wróci sam.',
    auto_check: 'Sprawdzamy automatycznie co 60 s',
    last_try: 'ostatnia próba {{time}}',
  },
  new_version: {
    title: 'Dostępna jest nowa wersja panelu',
    content:
      'Ta karta działa na starszej wersji. Odświeżenie wyczyści niezapisane formularze.',
    remind_hint: 'Przypomnimy ponownie za {{hours}} h',
    stuck_title: 'Ta karta wciąż działa na starej wersji',
    stuck_content:
      'Odświeżenie nie pomogło - przeglądarka podaje pliki z pamięci podręcznej. Naciśnij {{shortcut}}, aby wymusić pełne przeładowanie.',
  },
  email_verification_page: {
    success: 'Twoje konto jest już aktywne',
    tip: 'Teraz możesz zalogować się w aplikacji',
    new_email_title: 'Twój nowy adres email został potwierdzony',
    new_email: 'Możesz teraz logować się za pomocą nowego maila',
  },
  recover_password_page: {
    title: 'Stwórz nowe hasło do Twojego konta',
    success:
      ' Twoje hasło zostało zmienione poprawnie, teraz możesz zalogować się w aplikacji.',
  },
  tenant_request_details: {
    title: 'Prośba o status rezydenta',
    full_name: 'Imię i nazwisko:',
    message: 'Wiadomość:',
    login: 'Login:',
    contact_email: 'Email kontaktowy:',
    company_email: 'Email służbowy:',
    accepted: 'Zaakceptowana',
    rejected: 'Odrzucona',
    reply: 'Odpowiedź:',
    close_at: 'Data zamknięcia:',
    resolved_by: 'Zweryfikowana przez:',
  },
  user_message_details: {
    title: 'Szczegóły wiadomości',
    from: 'Od:',
    email: 'Email:',
    company: 'Firma:',
    date: 'Data zgłoszenia:',
    message: 'Wiadomość:',
    success: 'Wiadomość została wysłana poprawnie',
    reply: 'Odpowiedź:',
    closeAt: 'Data zamknięcia:',
    resolved_by: 'Odpowiedział(a):',
    delete_account: 'Prośba o usunięcie konta',
    os: 'System:',
    app: 'Wersja aplikacji:',
    api: 'Wersja API:',
    backend: 'Wersja backendu:',
  },
  tenant: {
    add_new_tenant: 'Dodaj nowego najemcę',
    edit_tenant: 'Edytuj najemcę',
    tenant_domains: 'Domeny najemcy:',
    add_domain: 'Dodaj domenę:',
    confirm_title: 'Czy na pewno chcesz edytować tego najemcę?',
    add_tenant_success: 'Najemca został utworzony',
    add_domain_success: 'Domena została utworzona',
  },
  email_verification_requests: {
    send_again: 'Wyślij ponownie',
    success: 'Email z kodem weryfikacyjnym został wysłany ponownie',
    delete_request: 'Czy na pewno chcesz usunąć wybrany kod weryfikacyjny?',
    delete_selected_requests:
      'Czy na pewno chcesz usunąć wybrane kody weryfikacyjne?',
  },
  error: {
    no_app: 'Nie znaleziono aplikacji.',
  },
  code: {
    100: 'OK',
    101: 'E-mail zweryfikowany',
    102: 'Profil zmieniony',
    103: 'Hasło zmienione',
    104: 'Status rezydenta zaktualizowany',
    105: 'E-mail potwierdzony',
    106: 'Użytkownik zalogowany',
    107: 'Użytkownik zarejestrowany',
    108: 'Zmiana adresu e-mail zaakceptowana. Podążaj za instrukcjami wysłanymi na adres e-mail.',
    109: 'Status rezydenta zaakceptowany',
    110: 'Status rezydenta odrzucony',
    111: 'Status zgody został zmieniony',
    200: 'Bilet zamówiony',
    201: 'Bilet znaleziony',
    202: 'Bilet został anulowany',
    300: 'Wiadomość wysłana',
    301: 'Zgłoszenie rozwiązane',
    400: 'Kliknij link weryfikacyjny wysłany na adres email',
    998: 'Zarezerwowane - nie używać',

    999: 'Wystąpił błąd 999, spróbuj ponownie później',
    1000: 'Niepoprawny adres email',
    1001: 'Wystąpił błąd 1001, spróbuj ponownie później',
    1002: 'Niepoprawny login lub hasło',
    1003: 'Email nie jest zweryfikowany',
    1004: 'Wystąpił błąd 1004, spróbuj ponownie później',
    1005: 'Błąd weryfikacji email',
    1006: 'Niepoprawny token, zaloguj się ponownie',
    1007: 'Wystąpił błąd 1007, spróbuj ponownie później',
    1008: 'Wystąpił błąd 1008, spróbuj ponownie później',
    1009: 'Nie można dodać użytkownika',
    1010: 'Problem z weryfikacją użytkownika',
    1011: 'Data w nieodpowiednim formacie',
    1012: 'Błąd wewnętrzny - nie można pobrać danych użytkownika',
    1013: 'Nie można potwierdzić statusu rezydenta',
    1014: 'Nie można zaktualizować użytkownika',
    1015: 'Nie można zaktualizować statusu rezydenta',
    1016: 'Nie można potwierdzić maila',
    1017: 'Podany login jest już zajęty.',
    1018: 'Podany e-mail jest już zarejestrowany.',
    1019: 'Brakuje parametru: email',
    1020: 'Brakuje parametru: kod weryfikacyjny',
    1021: 'Brakuje parametru: hasło.',
    1022: 'Nie można zmienić hasła.',
    1023: 'Niepoprawny typ email.',
    1024: 'Błąd wewnętrzny - nie można przetworzyć szablonu.',
    1025: 'Nieważny lub wygasły kod weryfikacyjny.',
    1026: 'Błędny parametr: action.',
    1027: 'Niestety podany adres e-mail nie został znaleziony na naszej liście rezydentów - wybierz opcję poniżej.',
    1028: 'Nie posiadasz wystarczających uprawnień',
    1029: 'Nie można przypisać roli',
    1030: 'Nie można usunąć przypisania roli',
    1031: 'Nie można dodać najemcy',
    1032: 'Nie można zmodyfikować najemcy',
    1033: 'Nie można usunąć najemcy',
    1034: 'Nie można dodać domeny',
    1035: 'Nie można edytować domeny',
    1036: 'Nie można usunąć domeny',
    1037: 'Nie można przypisać domeny',
    1038: 'Nie można cofnąć przypisania domeny',
    1039: 'Niepoprawna nazwa serwisu',
    1040: 'Nie można wysłać wiadomości email',
    1041: 'Nie posiadamy takiego konta w naszej bazie.',
    1042: 'Login jest za krótki',
    1043: 'Login zawiera niedozwolony znak',
    1044: 'Nie można wysłać ponownie - email jest nieznany lub kod weryfikacyjny nieważny',
    1100: 'Wymagane zgody nie zostały zaakceptowane',
    2000: 'Brak aktywnego biletu',
    2001: 'Brak aktywnego biletu',
    2002: 'Błąd wewnętrzny serwera biletowego',
    2003: 'Nie możesz kupić biletu wstecz',
    2004: 'Masz już aktywny bilet',
    2005: 'Błąd wewnętrzny - nieznany parametr dla serwera biletowego',
    2006: 'Błąd wewnętrzny serwera biletów',
    2007: 'Byłeś blisko. Brak wolnego slotu na wybraną przez Ciebie datę.',
    2008: 'Nie można zamówić biletu',
    2009: 'Data niedostępna',
    2010: 'Ups... Nie możesz zarezerwować biletu z wyprzedzeniem większym niż 31 dni.',
    2011: 'Bilet został już wykorzystany',
    3000: 'Nieznany temat problemu',
    3001: 'Nie można wysłać zgłoszenia, spróbuj ponownie później',
    3002: 'Nie można pobrać zgłoszenia',
    4005: 'Miejsce jest zajęte poza pulą w wybranym dniu',
    4036: 'Ten pracownik ma już rezerwację z puli w wybranym dniu',
    4040: 'Pracownik nie zaakceptował udostępniania danych przez pracodawcę',
    4041: 'Użytkownik nie wyraził zgody na udostępnianie danych pracodawcy',
  },
  user_details: {
    title: 'Szczegóły użytkownika',
    confirm_modal_title: 'Potwierdź zmiany',
    firstName: 'Imię',
    lastName: 'Nazwisko',
    company: 'Firma',
    user_roles: 'Role użytkownika',
    no_roles: 'Brak ról użytkownika',
    choose_role: 'Wybierz role użytkownika',
    unconfirmed_user: '* Niepotwierdzony użytkownik',
    tenant_change_success: 'Najemca został przypisany',
    tenant_deleted_success: 'Przypisany najemca został usunięty',
    add_role: 'Rola została przypisana',
    delete_role: 'Rola została usunięta',
    assigned_restaurants: 'Przypisane restauracje',
    no_restaurants: 'Brak restauracji',
    choose_restaurant: 'Wybierz restaurację',
    add_restaurant: 'Restauracja została przypisana',
    delete_restaurant: 'Restauracja została usunięta',
    switch_lock_enable: 'Użytkownik odblokowany',
    switch_lock_disabled: 'Użytkownik zablokowany',
    lock: 'Blokada użytkownika',
    lock_success: 'Użytkownik został zablokowany',
    unlock_success: 'Użytkownik został odblokowany',
    parking_no_plate: 'Brak numerów rejestracyjnych',
    parking_placeHolder: 'Numery rejestracyjne',
    user_parking: 'Numery rejestracyjne samochodów użytkownika',
    acceptances: 'Zgody użytkownika:',
    global_searcher: 'Wyszukiwarka informacji:',
    add_feature: 'Moduł został przypisany',
    delete_feature: 'Moduł został usunięty',
    user_features: 'Moduły użytkownika',
    no_features: 'Brak modułów',
    choose_feature: 'Wybierz moduł',
    shared_parking_enabled: 'Funkcjonalność włączona',
    shared_parking_disabled: 'Funkcjonalność wyłączona',
    share_parking_feature: 'Współdzielenie miejsc parkingowych',
    access_card: 'Karta dostępowa',
    access_card_change_success: 'Karta dostępowa została przypisana',
    car_plate: 'Tablica rejestracyjna',
    remove_card: 'Usuń kartę',
    remove_card_confirmation:
      'Czy na pewno chcesz usunąć przypisanie karty do użytkownika?',
    add_card: 'Dodaj kartę dostępową',
    chose_card: 'Wybierz typ karty i wpisz numer',
    chose_card_type: 'Wybierz z poniższych opcji kartę, którą chcesz dodać',
    enter_card_number: 'Wpisz numer karty',
    change_card_type: 'Zmień typ karty',
    add_card_format: 'Dodaj format karty',
    eyebrow: 'Profil parkingowy',
    tab_settings: 'Ustawienia',
    tab_reservations: 'Rezerwacje',
    assign_to_unlock: 'Przypisz do usługi, aby odblokować rezerwacje',
    access_data: 'Dane dostępowe',
    car_plates: 'Tablice rejestracyjne',
    car_plate_placeholder: 'np. GD 12345',
    no_car_plates: 'Brak przypisanych tablic rejestracyjnych.',
    add_car_plate: 'Dodaj tablicę',
    add_next_car_plate: 'Dodaj kolejną tablicę',
    remove_car_plate: 'Usuń tablicę',
    parking_access: 'Dostęp do parkingu',
    service_profile: 'Profil usługi',
    profile_legend_open: 'Zobacz dostępne profile',
    profile_legend_title: 'Profile usługi',
    profile_legend_intro:
      'Profil decyduje o limitach rezerwacji użytkownika w tej usłudze. Wybierz go przed przypisaniem do usługi.',
    profile_badge_default: 'domyślny',
    profile_badge_assigned: 'przypisany',
    profile_limit_simultaneous: 'Liczba jednoczesnych rezerwacji',
    profile_limit_advance: 'Maksymalne wyprzedzenie rezerwacji',
    profile_limit_duration: 'Maksymalna długość rezerwacji',
    profile_limit_users: 'Limit użytkowników profilu',
    profile_limit_unlimited: 'bez ograniczeń',
    profile_users_assigned: 'przypisanych użytkowników',
    profile_parkings: 'Dostępne parkingi',
    reservation_parking_unknown: 'Parking nieokreślony',
    profile_email_note: 'Własna treść powiadomienia e-mail:',
    profile_no_limits: 'Brak informacji o limitach tego profilu.',
    profile_days_short: 'dni',
    reserve_on_behalf: 'Rezerwacja w imieniu',
    reserve_on_behalf_info:
      'Akcja wysyła automatyczne powiadomienie e-mail oraz push do użytkownika.',
    reserve: 'Zarezerwuj',
    reserve_coming_soon: 'Ta akcja będzie dostępna wkrótce.',
    current_reservations: 'Obecne rezerwacje',
    reservation_active: 'Aktywna',
    no_active_reservations: 'Brak aktywnych rezerwacji.',
    cancelled_reservations: 'Anulowane rezerwacje',
    no_cancelled_reservations: 'Brak anulowanych rezerwacji.',
    cancelled_whole: 'Cała rezerwacja',
    cancelled_whole_with_days: 'Cała rezerwacja · {{n}} dni',
    cancelled_single_day: 'Na dzień',
    cancelled_from_reservation: 'z rezerwacji {{range}}',
    cancelled_same_day: 'W dniu rezerwacji',
    cancelled_at_value: 'Anulowano {{value}}',
    cancelled_by_value: 'przez {{value}}',
    cancelled_time_unknown: 'Brak znacznika czasu',
    cancelled_show_all: 'Pokaż wszystkie ({{n}})',
    cancelled_show_less: 'Pokaż mniej',
    save_changes: 'Zapisz zmiany',
    unlock_after_assign: 'Dostępne po przypisaniu użytkownika do usługi.',
    default_profile_hint_single:
      'Profil zostanie przypisany automatycznie podczas dodawania do usługi.',
    default_profile_hint_multiple:
      'Domyślny profil zostanie przypisany podczas dodawania do usługi — możesz go zmienić.',
    reserve_modal: {
      title: 'Rezerwacja w imieniu',
      step1_title: 'Wybierz dni rezerwacji',
      step1_sub: 'Zaznacz dni, dla których chcesz utworzyć rezerwację.',
      mode_single: 'Pojedyncze dni',
      mode_range: 'Zakres',
      range_hint_start: 'Kliknij pierwszy dzień okresu.',
      range_hint_end:
        'Teraz kliknij ostatni dzień — możesz przejść do kolejnego miesiąca.',
      select_month: 'Zaznacz cały miesiąc ({{n}})',
      unselect_month: 'Odznacz ten miesiąc',
      range_skipped:
        'Dni niedostępne w tym okresie zostały pominięte ({{count}}).',
      clear_all: 'Wyczyść wszystko',
      legend_selected: 'wybrany',
      legend_booked: 'ma rezerwację',
      legend_full: 'brak miejsc',
      legend_blocked: 'niedostępny',
      user_limit_reached:
        'Użytkownik osiągnął maksymalną liczbę rezerwacji — nie można utworzyć kolejnej.',
      user_limit_reached_count_one:
        'Użytkownik osiągnął maksymalną liczbę rezerwacji ({{count}}) — nie można utworzyć kolejnej.',
      user_limit_reached_count_few:
        'Użytkownik osiągnął maksymalną liczbę rezerwacji ({{count}}) — nie można utworzyć kolejnej.',
      user_limit_reached_count_many:
        'Użytkownik osiągnął maksymalną liczbę rezerwacji ({{count}}) — nie można utworzyć kolejnej.',
      reason_already_reserved: 'Użytkownik ma już rezerwację w tym dniu.',
      reason_user_reservation_limit:
        'Użytkownik osiągnął maksymalną liczbę rezerwacji.',
      reason_parking_user_limit:
        'Limit użytkowników na tym parkingu został wyczerpany.',
      reason_pool_user_limit:
        'Limit użytkowników w tej puli został wyczerpany.',
      reason_profile_user_limit:
        'Limit użytkowników w tym profilu został wyczerpany.',
      reason_pool_full: 'Brak wolnych miejsc w tym dniu.',
      reason_beyond_max_advance:
        'Dzień wykracza poza okres, na jaki można rezerwować.',
      reason_in_the_past: 'Dzień już minął.',
      reason_pool_not_valid:
        'Pula lub przypisanie użytkownika do niej nie jest aktywne.',
      reason_pass_disabled: 'Abonament parkingowy tej puli jest wyłączony.',
      reason_no_parking_assigned:
        'Profil nie ma przypisanego żadnego parkingu.',
      reason_state_booked: 'Użytkownik ma już rezerwację w tym dniu.',
      reason_state_blocked: 'Dzień niedostępny do rezerwacji.',
      reason_unknown: 'Dzień niedostępny do rezerwacji.',
      selected_dates: 'Wybrane daty',
      no_days: 'Brak wybranych dni.',
      step2_title: 'Wybierz wariant miejsca',
      step2_sub: 'Warianty aktualizują się na podstawie wybranych dni.',
      single_hall: 'Komplet w jednej hali',
      mixed_variants: 'Warianty mieszane',
      both_slots: 'oba sloty ({{days}})',
      notify_user: 'Powiadom użytkownika (e-mail i push)',
      create_reservation: 'Utwórz rezerwację',
      days_one: '{{count}} dzień',
      days_few: '{{count}} dni',
      days_many: '{{count}} dni',
      loading: 'Ładowanie dostępności…',
      loading_variants: 'Ładowanie wariantów…',
      no_variants: 'Brak dostępnych wariantów dla wybranych dni.',
      no_variants_pool_full: 'Brak wolnych miejsc w wybranych dniach.',
      select_days_first: 'Najpierw wybierz dni w kalendarzu.',
      ordering_disabled:
        'Rezerwacje online są obecnie wyłączone — widok tylko do podglądu dostępności.',
      max_days_reached: 'Osiągnięto maksymalną liczbę dni ({{count}}).',
      error_generic: 'Coś poszło nie tak. Spróbuj ponownie.',
      error_heading: 'Wystąpił błąd',
    },
    cancel_reservation_title: 'Anuluj całą rezerwację',
    cancel_reservation_confirm: 'Anuluj rezerwację',
    cancel_whole: 'Anuluj całość',
    cancel_day: 'Anuluj dzień',
    no_reservation_days: 'Brak informacji o dniach tej rezerwacji.',
    reservation_days: 'Dni rezerwacji',
    cancel_day_title: 'Anuluj wybrany dzień',
    cancel_day_confirm: 'Anuluj dzień',
    select_all_days: 'Zaznacz wszystkie',
    unselect_all_days: 'Odznacz wszystkie',
    select_days_hint:
      'Kliknij dzień, aby go zaznaczyć. Shift + klik zaznacza zakres.',
    selected_days_count: 'Zaznaczone dni: {{n}}',
    clear_day_selection: 'Wyczyść',
    cancel_selected_days: 'Anuluj zaznaczone ({{n}})',
    cancel_days_title: 'Anuluj zaznaczone dni',
    cancel_days_done: 'Anulowano dni: {{n}}.',
    show_days: 'Pokaż dni',
    hide_days: 'Ukryj dni',
    cancel_default_comment: 'Anulowano przez office managera',
    edit_reservation: 'Edytuj dane rezerwacji',
    reservation_data_saved: 'Zapisano dane rezerwacji.',
  },
  user_search: {
    garden_tickets: 'Pokaż bilety do garden',
    user_acceptance_history: 'Pokaż historie zgód użytkownika',
    parking_subcriptions: 'Pokaż abonamenty/bilety parkingowe',
    user_messages_new: 'Pokaż nowe wiadomości od użytkownika',
    user_messages_closed: 'Pokaż zamknięte wiadomości od użytkownika',
    no_questions: 'Brak zapytań',
    get_query: 'Wybierz zapytanie',
  },
  table_component: {
    download_csv: 'Pobierz CSV',
  },
  columns: {
    full_name: 'Imię i Nazwisko',
    login: 'Login',
    main_email: 'Email główny',
    work_email: 'Email służbowy',
    card_number: 'Numer karty',
    unconfirmed_email: 'Niepotwierdzony email',
    created_at: 'Data wysłania',
    company: 'Firma',
    tenant: 'Najemca',
    domains: 'Domeny mailowe',
    roles: 'Role',
    message: 'Treść wiadomości',
    message_date: 'Data zgłoszenia',
    close_date: 'Data zamknięcia',
    status: 'Status',
    visit_date: 'Data odwiedzin',
    qr_code: 'Kod QR',
    reply: 'Odpowiedź',
    creation_date: 'Data utworzenia',
    dish_name: 'Nazwa dania',
    price: 'Cena',
    availability: 'Dostępne',
    visible: 'Widoczne',
    diet_type: 'Rodzaj dania',
    category: 'Kategoria',
    last_mobile_app: 'Ostatnie logowanie z aplikacji',
    last_seen: 'Data ostatniego logowania',
    api_version: 'Wersja API',
    car_plate: 'Numery rejestracyjne samochodów',
    features: 'Moduły',
    ticket_type: 'Typ biletu',
    order_id: 'Id zamówienia',
    payment_status: 'Status płatności',
    parking_pool: 'Parking pool',
    resident: 'Rezydent',
    account_status: 'Status konta',
    card_type: 'Typ karty',
    valid_from: 'Ważny od',
    valid_to: 'Ważny do',
    reservation_status: 'Status rezerwacji',
    subscription_status: 'Status abonamentu',
    feature_enabled: 'Funkcjonalność włączona',
    place: 'Miejsce',
    user_assigned: 'Przypisany do usługi',
    profile: 'Profil',
    building: 'Budynek',
    parkings: 'Parkingi',
    service: 'Usługa',
    card_and_plate: 'Dane',
  },
  non_data: {
    non_data: '[Brak]',
  },
  user_details_table: {
    createdAt: 'Data zmiany',
    service: 'Jaki to serwis?',
    title: 'Tytuł zgody',
    required: 'Czy zgoda jest wymagana?',
    current: 'Czy uzytkownik wyraził zgode?',
    content: 'Treść zgody',
    buttonBack: 'Zamknij i wróć do Listy Użytkowników',
    topic: 'Historia zmian uzytkownika:',
  },
  user_acceptances: {
    required: 'Czy zgoda jest wymagana?:',
    selected: 'Czy uzytkownik zaznaczył zgode?:',
    service: 'Którego modułu dotyczy zgoda:',
    current: 'Czy zgoda/regulamin aktualnie obowiązuje:',
    createdAt: 'Data pierwszej decyzji:',
    modifiedAt: 'Data ostatniej decyzji:',
  },
  bool: {
    yes: 'Tak',
    no: 'Nie',
  },
  payment_history: {
    details_title: 'Szczegóły płatności',
    payment_date: 'Data płatności',
    ticket_id: 'Id biletu',
    ticket_type: 'Typ biletu',
    ticket_start: 'Bilet od',
    ticket_stop: 'Bilet do',
    product_name: 'Nazwa produktu',
    seller_company: 'Sprzedawca',
    seller_nip: 'NIP sprzedawcy',
    invoice: 'Faktura',
    invoice_data: 'Dane do faktury',
    parking_name: 'Nazwa parkingu',
    fv: 'Faktura Vat',
    payment_id: 'Id płatności',
    account_firstname: 'Imie',
    account_lastname: 'Nazwisko',
    email: 'Email',
    nip: 'Nip',
    name: 'Nazwa firmy',
    zipcode: 'Kod pocztowy',
    street: 'Ulica',
    city: 'Miasto',
    country: 'Kraj',
    car_plate_1: 'Numer Rejestracyjny',
    car_plate_2: 'Numer Rejestracyjny',
    access_card_id: 'Numer karty OBC',
    tenant_name: 'Najemca',
    payment_value_gross: 'Cena zakupu',
    payment_history: 'Historia płatności',
    payment_status: 'Status płatności',
    subscription: 'Abonament',
    oneTimeTicket: 'Bilet jednorazowy',
    ticket_number: 'Numer biletu',
    dates: 'Daty',
    car_plates: 'Numery rejestracyjne',
    price: 'Kwota',
    created_at: 'Data utworzenia',
    payment: 'Płatność',
    lease_from: 'Najem od',
    lease_to: 'Najem do',
    building: 'Budynek',
    locker_number: 'Numer szafki',
    locker_payment_history: 'Historia płatności za szafki',
    parking_payment_history: 'Historia płatności za parking',
  },
  parking_subscriptions_products_list: {
    parking_id: 'ID Parkingu',
    parking_name: 'Nazwa Parkingu',
    product_duration: 'Czas trwania abonamentu',
    product_name: 'Nazwa produktu',
    product_id: 'Id produktu',
    product_price: 'Cena produktu',
    product_valid_from: 'Oferta dostępna od',
    product_valid_to: 'Oferta wana do',
    active: 'Czy oferta jest aktywna?',
    max_spaces_to_sell: 'Miejsc do sprzedaży',
    seller_company_name: 'Firma sprzedająca',
    product_regulations: 'Link do regulaminu i produktu',
    subscriptions_list: 'Lista produktów abonamentowych',
  },
  parking_subscription_form: {
    add_title: 'Dodaj Abonament',
    edit_title: 'Edytuj Abonament',
    name_and_price: 'Name and price',
    valid_from: 'Produkt dostępny od:',
    duration: 'Czas trwania abonamentu:',
    price: 'Cena abonamentu:',
    price_label: 'Cena',
    limit: 'Liczba miejsc parkingowych do sprzedaży:',
    max_advance:
      'Maksymalna liczba dni, w której przed użyciem biletu można dokonać zakupu:',
    min_advance:
      'Minimalna liczba dni, w której przed użyciem biletu można dokonać zakupu:',
    after_end:
      'Ile dni po wygaśnieciu biletu miejsce parkingowe będzie zarezerwowane:',
    valid_to: 'Produkt dostępny do:',
    active: 'Czy produkt jest aktywny:',
    select_parking: 'Wybierz Parking',
    select_parking_no: 'Brak Parkingów',
    rules: 'Regulamin',
    select_no_rules: 'Brak Regulaminu',
    select_rules: 'Wybierz regulamin',
    company: 'Firma sprzedająca abonament',
    select_company: 'Wybierz firmę',
    select_company_no: 'Brak firm',
    add: 'Dodaj',
    active_yes: 'Tak, produkt jest aktywny',
    active_no: 'Nie, produkt nie jest aktywny',
    date: 'Wybierz date',
    subscription: 'Nazwa Abonamentu:',
    subscription_pl: 'Polska nazwa abonamentu',
    subscription_en: 'Angielska nazwa abonamentu',
    days: 'Dni',
    places: 'Miejsc',
    show_regulation: 'Pokaż treść regulaminu',
    min_advance_others:
      'Minimalna liczba dni roboczych, w której przed użyciem biletu można dokonać zakupu, dla budynków innych niż mój:',
    sort: 'Sortowanie:',
    amano_product_no: 'Numer produktu Amano:',
    value: 'Wartość',
    number: 'Numer',
  },
  parking_list: {
    parking_list: 'Lista parkingów',
    edition_parking: 'Edycja parkingu',
    name: 'Nazwa parkingu',
    limit_place: 'Limit miejsc parkigowych',
    places: 'Miejsc',
    building: 'Lista przypisanych budynków do parkingu:',
    building_list: 'Rozwiń liste budynków',
    building_list_no: 'Brak przypisanych budynków',
    parking_places: 'Lista dedykowanych miejsc parkingowych',
    parking_places_select: 'Rozwiń liste miejsc dedykowanych',
    parking_places_select_no: 'Brak miejsc dedykowanych',
    remarks: 'Uwagi',
    is_dedicate_places: 'Czy są miejsca dedykowane?',
    dedicate_places_number: 'Liczba miejsc dedykowanych',
    parking_building: 'Budynki przypisane do parkingu',
    company: 'Firma obsługująca parking',
    company_email: 'Email do firmy obsługującej parking',
    go_to_places: 'Przejdź do miejsc parkingowych',
    date: 'Data',
    capacity: 'Pojemność',
    sold: 'Sprzedane',
    used: 'Użyte',
    parking_occupancy_report: 'Raport zajętości parkingów',
  },
  sold_parking_items: {
    valid_subscriptions_list: 'Lista aktualnych abonamentów',
    sold_one_time_tickets: 'Lista sprzedanych biletów jednorazowych',
    valid_from: 'Ważny od',
    valid_to: 'Ważny do',
    product_name: 'Nazwa produktu',
    product_id: 'Id produktu',
    car_plates: 'Numery rejestracyjne',
    car_plate: 'Numer rejestracyjny',
    status: 'Status abonamentu',
    ticket_status: 'Status biletu',
    purchase_date: 'Data zakupu',
    payment_amount: 'Kwota płatności',
    payment_status: 'Status płatności',
    payment_id: 'ID płatności OBC',
    payment_external_id: 'ID płatności PayU',
    payment_created_at: 'Data płatności',
    logs: 'Logi:',
    no_logs: 'Brak logów',
    log_message: 'Wiadomość',
    created_at: 'Data utworzenia',
    valid_to_info: 'z datą ważności równą lub wyższą:',
    details_title: 'Szczegóły abonamentu',
    user: 'Dane kupującego',
    dates: 'Daty',
    related_tickets_and_payments: 'Powiązane bilety i płatności:',
    ticket: 'Bilet',
    place: 'Miejsce',
    parameters: 'Parametry:',
    name: 'nazwa',
    type: 'typ',
    value: 'wartość',
    sync_with_amano: 'Synchronizuj z Amano',
    cancel_subscription: 'Anuluj abonament',
    sync_date_and_time: 'Data i godzina synchronizacji',
    subscription_cancelled: 'Abonament został anulowany',
    cancel_subscription_info: 'Czy na pewno chcesz anulować ten abonament?',
    ticket_number: 'Numer biletu',
    ticket_details: 'Sczegóły biletu',
    comment: 'Komentarz',
    action_comment: 'Komentarz anulowania/resynchronizacji',
    reschedule_success: 'Abonament został zsynchronizowany',
    sale_id: 'ID sprzedaży',
    tenant: 'Najemca',
    payment_value: 'Cena zakupu',
  },
  parking_subscription_status: {
    active: 'Aktywny',
    cancelled: 'Anulowany',
    error: 'Błąd',
    new: 'Nowy',
    past: 'Przeszły',
    pending: 'W toku',
  },
  filter: {
    title: 'Filtrowanie zaawansowane po kolumnie',
    choose_column: 'Wybierz kolumne',
    choose_column_no: 'Brak kolumn',
    value: 'Wpisz fraze',
  },
  feature: {
    gastro_mobile: 'Restauracja mobile',
    gastro_admin: 'Restauracja admin',
    parking_mobile: 'Parking mobile',
    parking_admin: 'Parking admin',
    olivia_news: 'Olivia news',
    survey_with_upsert: 'Ankiety z upsert',
  },
  logs: {
    logs: 'Logi:',
    no_logs: 'Brak logów',
    parameters: 'Parametry:',
    name: 'nazwa',
    type: 'typ',
    value: 'wartość',
  },
  parking_places: {
    parking_place_statuses: 'Statusy miejsc parkingowych',
    parking_place_reservations: 'Rezerwacje miejsc parkingowych',
    level: 'Poziom',
    place: 'Miejsce',
    shared: 'Współdzielone',
    lease_term: 'Okres najmu',
    company: 'Firma',
    tenant: 'Najemca',
    from: 'Od',
    to: 'Do',
    show_place_numbers: 'Pokaż numery miejsc',
    available: 'Dostępne',
    unavailable: 'Niedostępne',
    reserved: 'Zarezerwowane',
    occupied: 'Zajęte',
    to_rent: 'Do wynajęcia',
    yes: 'Tak',
    no: 'Nie',
    hide_numbers: 'Ukryj numery miejsc',
    show_numbers: 'Pokaż numery miejsc',
    unlimited: 'bezterminowo',
    change_places_status: 'Zmień status miejsc parkingowych',
    change_status: 'Zmień status',
    new_status: 'Nowy status',
    comment: 'Komentarz',
    change_status_button_hint: 'Wybierz status oraz miejsca z listy',
  },
  reservation_status: {
    ready_to_rent: 'Do wydania',
    rented_overdue: 'Do zdania',
    rented: 'Wynajęte',
    available: 'Wolne',
    unavailable: 'Niedostępne',
    broken: 'Uszkodzone',
    reserved: 'Zarezerwowane',
    prereserved: 'Wstępna rezerwacja',
    error: 'Error',
    cancelled: 'Anulowano',
    finished: 'Zakończona',
  },
  payment_status: {
    completed: 'Zakończona',
    confirmed: 'Potwierdzona',
    error: 'Błąd',
    failed: 'Nieudana',
    new: 'Nowa',
    processing: 'W toku',
    received: 'Otrzymana',
    cancelled: 'Anulowana',
  },
  parking_ticket_status: {
    new: 'Nowy',
    reserved: 'Zarezerwowany',
    processing: 'W toku',
    paid: 'Opłacony',
    cancelled: 'Anulowany',
    unavailable: 'Niedostępny',
    error: 'Błąd',
  },
  parking_pool_data: {
    loading_stats: 'Ładowanie danych…',
    amano_product_id: 'ID produktu amano',
    places_amount: 'Liczba miejsc',
    max_simultaneous_users: 'Max. liczba użytkowników',
    max_continuous_days: 'Max. liczba dni jednej rezerwacji',
    max_advanced_days: 'Max. liczba dni z wyprzedzeniem dla rezerwacji',
    max_simultaneous_reservations: 'Max. liczba jednoczesnych rezerwacji',
    no_product: 'Brak przypisanego produktu',
    no_valid: 'Brak przypisanych miejsc parkingowych',
    no_valid_desc:
      'Do Twojej organizacji nie przypisano żadnych miejsc parkingowych. Zgłoś problem do administratora parkingów.',
    no_parking_data: 'Brak danych parkingu',
    no_parking_data_desc:
      'Moduł parkingowy nie jest skonfigurowany dla tej organizacji. Skontaktuj się z administratorem systemu, aby aktywować usługę.',
    eyebrow: 'Parking · Pulpit',
    title: 'Dane i analityka',
    subtitle: 'Konfiguracja usługi oraz wykorzystanie miejsc parkingowych.',
    no_building: 'Bez przypisanego budynku',
    buildings_title: 'Miejsca wg budynków',
    buildings_as_of_today: 'Stan miejsc na dziś',
    buildings_as_of: 'Stan miejsc na {{date}}',
    buildings_planned_for: 'Rezerwacje na {{date}}',
    used_unknown_yet:
      'Zajętość dla przyszłych dni nie jest jeszcze znana — pokazujemy rezerwacje.',
    utilization_unknown_yet: 'rezerwacje',
    col_building: 'Budynek',
    col_places: 'Miejsca',
    col_reserved: 'Zarezerwowane',
    col_used: 'Zajęte',
    col_free: 'Wolne',
    col_utilization: 'Wykorzystanie',
    buildings_shared_with: 'dzielony z: {{buildings}}',
    buildings_shared_footnote:
      'Parkingi dzielone między budynki liczone są w każdym z nich, więc suma wierszy może przekraczać liczbę miejsc w umowie.',
    buildings_over_capacity: 'Rezerwacje przekraczają liczbę miejsc.',
    no_buildings: 'Brak danych o budynkach w wybranym okresie.',
    period_day: 'Dzień',
    day_today: '· dziś',
    period_30: '30 dni',
    period_90: '90 dni',
    period_year: 'Rok',
    avg_utilization_short: 'średnie wykorzystanie',
    product_config: 'Konfiguracja produktu',
    cfg_parkings: 'Parkingi',
    cfg_places_count: 'Miejsca łącznie',
    cfg_max_users: 'Max. użytkowników',
    cfg_unlimited: 'bez ograniczeń',
    cfg_profiles: 'Profile',
    profiles_title: 'Profile parkingowe',
    profiles_hint: 'Limity rezerwacji zależą od profilu użytkownika.',
    profile_users: 'użytkownicy: {{n}}',
    no_profiles: 'Brak zdefiniowanych profili parkingowych.',
    kpi_avg_utilization: 'Średnie wykorzystanie',
    chart_usage_over_time: 'Wykorzystanie miejsc w czasie',
    legend_occupancy: 'Zajętość',
    legend_reservations: 'Rezerwacje',
    chart_parkings_title: 'Miejsca wg parkingów',
    places_count: 'miejsca: {{n}}',
    other_parkings: 'Pozostałe ({{n}})',
    places: 'miejsc',
    legend_capacity: 'Pojemność',
    kpi_period_hint: 'w wybranym okresie',
    kpi_delta_up: '+{{pp}} pp vs poprzedni okres',
    kpi_delta_down: '-{{pp}} pp vs poprzedni okres',
    kpi_delta_flat: 'bez zmian vs poprzedni okres',
    parking_utilization: 'wykorzystanie {{pct}}%',
    total_available_today: 'Dostępne dziś',
    total_available_on: 'Dostępne {{date}}',
    no_stats: 'Brak danych o zajętości w wybranym okresie.',
    stats_error: 'Nie udało się pobrać danych o zajętości miejsc.',
    employee_usage_title: 'Wykorzystanie wg pracowników',
    employee_usage_hint:
      'Kto rezerwuje miejsce i z niego nie korzysta — dane za wybrany okres.',
    employee_col_name: 'Pracownik',
    employee_col_reserved: 'Zarez. dni',
    employee_col_used: 'Wykorz.',
    employee_col_unused: 'Nieużyte',
    employee_col_cancelled: 'Anulowane',
    employee_col_ratio: 'Wykorzystanie',
    employee_usage_expand: 'Pokaż wszystkich ({{n}})',
    employee_usage_collapse: 'Zwiń listę',
    employee_usage_empty: 'Brak rezerwacji pracowników w wybranym okresie.',
    employee_usage_error:
      'Nie udało się pobrać danych o wykorzystaniu przez pracowników.',
    employee_usage_no_data:
      'Brak danych o wykorzystaniu miejsc przez pracowników w wybranym okresie.',
  },
  parking_pool_occupancy_report: {
    map_opened_instead:
      'Nie udało się zapisać pliku — mapa otwarta w nowej karcie.',
    download_map_file: 'Pobierz plik',
    no_map: 'Brak mapy',
    no_map_hint: 'Mapa tego parkingu nie została jeszcze dodana.',
    map_load_error: 'Nie udało się wczytać mapy',
    map_load_error_hint: 'Adres mapy jest ustawiony, ale plik się nie otwiera.',
    map_zoom: 'Powiększ',
    open_in_tab: 'Otwórz w nowej karcie',
    date: 'Data',
    capacity: 'Liczba aktywnych użytkowników',
    sold: 'Zarezerwowane',
    used: 'Użyte',
    max_user_count: 'Maksymalna liczba użytkowników',
    max_places_count: 'Liczba miejsc wg umowy',
    places_count: 'Liczba miejsc',
    eyebrow: 'Parking',
    title: 'Miejsca wg budynków',
    subtitle:
      'Dostępność miejsc w każdym budynku oraz spersonalizowane mapy parkingów do pobrania.',
    kpi_total_places: 'Miejsca łącznie',
    kpi_available_now: 'Dostępne teraz',
    kpi_occupied: 'Zajęte',
    availability_low: 'Niska dostępność',
    availability_medium: 'Średnia dostępność',
    availability_good: 'Dobra dostępność',
    available_of: '/ {{total}} dostępnych',
    map_badge: 'MAPA',
    map_alt: 'Mapa parkingu',
    download_map: 'Pobierz mapę',
    map_title: 'Mapa parkingu · {{name}}',
    map_subtitle: 'Spersonalizowana mapa miejsc dla tego budynku.',
    download_pdf: 'Pobierz PDF',
    map_downloaded: 'Pobrano mapę: {{name}}.pdf',
    no_parking_data: 'Brak danych parkingu',
    no_parking_data_desc:
      'Dane o zajętości miejsc parkingowych są niedostępne. Moduł parkingowy nie jest skonfigurowany dla tej organizacji.',
    kpi_reserved_today: 'Zarezerwowane dziś',
    as_of: 'Stan na {{date}}',
    parkings_in_building: 'Parkingi: {{names}}',
    card_used: 'zajęte {{used}} z {{capacity}}',
    card_reserved: 'zarezerwowane: {{reserved}}',
    shared_with: 'Parking dzielony z: {{buildings}}',
    shared_note:
      'Liczby dotyczą całego parkingu i powtarzają się w każdym z tych budynków — nie sumuj ich między kartami.',
    no_building: 'Bez przypisanego budynku',
    no_stats: 'Brak danych o zajętości miejsc na dziś.',
    stats_error: 'Nie udało się pobrać danych o zajętości miejsc.',
  },
  parking_pool_reservations: {
    no_action_for_status:
      'Rezerwacji ze statusem „{{status}}" nie można anulować',
    scope_whole: 'Cała rezerwacja',
    scope_whole_desc: 'Anuluje rezerwację ze wszystkimi jej dniami.',
    scope_days: 'Wybrane dni',
    scope_days_desc: 'Rezerwacja zostaje, znikają tylko zaznaczone dni.',
    days_loading: 'Wczytywanie dni rezerwacji…',
    days_unavailable: 'Brak danych o poszczególnych dniach tej rezerwacji.',
    days_title: 'Dni rezerwacji ({{n}})',
    days_select_all: 'Zaznacz wszystkie',
    days_clear: 'Odznacz',
    days_all_selected_hint:
      'Zaznaczono wszystkie dni — efekt będzie taki sam jak anulowanie całej rezerwacji, ale użytkownik nie dostanie powiadomienia.',
    confirm_whole: 'Anuluj całą rezerwację',
    confirm_days: 'Anuluj wybrane dni ({{n}})',
    toast_days_cancelled: 'Anulowano dni rezerwacji: {{n}}',
    eyebrow: 'Parking',
    title: 'Rezerwacje parkingów firmowych',
    subtitle: 'Pełna historia rezerwacji wraz z dokładnym czasem anulowania.',
    search_placeholder: 'Szukaj rezerwacji…',
    filter_status: 'Status',
    filter_status_all: 'Wszystkie statusy',
    col_parking: 'Parking',
    col_full_name: 'Imię i nazwisko',
    col_email: 'E-mail',
    col_card_number: 'Nr karty',
    col_valid_from: 'Ważny od',
    col_valid_to: 'Ważny do',
    col_status: 'Status',
    col_period: 'Okres',
    status_cancelled_day: 'Anulowany dzień',
    status_any_cancelled: 'Wszystkie anulowania',
    day_of_reservation: 'z rezerwacji {{period}}',
    days_cancelled_one: 'anulowano {{count}} dzień',
    days_cancelled_few: 'anulowano {{count}} dni',
    days_cancelled_many: 'anulowano {{count}} dni',
    days_cancelled_of: 'anulowano {{count}} z {{total}} dni',
    col_cancelled_at: 'Anulowano',
    col_cancelled_by: 'Anulował',
    col_row_type: 'Typ',
    row_type_reservation: 'Rezerwacja',
    col_cancelled_day: 'Anulowany dzień',
    col_cancelled_same_day: 'Anulowane w dniu rezerwacji',
    col_cancelled_days: 'Anulowane dni',
    pagination_reservations: '{{from}}–{{to}} z {{count}} rezerwacji',
    col_actions: 'Akcje',
    cancelled_same_day: 'w dniu rezerwacji',
    cancelled_time_unknown: 'Brak znacznika czasu',
    cancel: 'Anuluj',
    bulk_cancel: 'Anuluj zaznaczone rezerwacje',
    bulk_cancel_some: 'Anuluj rezerwacje z zaznaczenia ({{count}})',
    bulk_cancel_none: 'Brak rezerwacji do anulowania w zaznaczeniu',
    download_selected_csv: 'Pobierz zaznaczone ({{count}})',
    cancel_reservation: 'Anuluj rezerwację',
    reservation_of_user: 'Rezerwacja użytkownika',
    period: 'Okres',
    notify_user: 'Powiadom użytkownika (e-mail i push)',
    back: 'Wróć',
    toast_cancelled_one:
      'Rezerwacja anulowana · {{parking}}. Powiadomienie e-mail i push wysłane.',
    toast_cancelled_many:
      '{{n}} rezerwacji anulowano. Powiadomienia e-mail i push wysłane.',
    toast_cancelled_partial:
      'Anulowano {{ok}} rezerwacji, {{failed}} nie powiodło się.',
    cancel_default_comment: 'Anulowano przez office managera',
    toast_generating_csv: 'Generowanie pliku CSV… plik zostanie pobrany.',
    status_active: 'Aktywna',
    status_cancelled: 'Anulowana',
    status_past: 'Zakończona',
    status_new: 'Nowa',
    status_pending: 'Oczekująca',
    status_error: 'Błąd',
  },
  parking_pool_users: {
    select_requires_service:
      'Akcje masowe są dostępne dla użytkowników przypisanych do usługi lub mających kartę dostępową i tablicę rejestracyjną',
    eyebrow: 'Parking',
    title: 'Wszyscy użytkownicy',
    subtitle:
      'Zarządzaj dostępem do budynków, kartami i profilami parkingowymi.',
    search_placeholder: 'Szukaj po nazwisku, loginie lub e-mailu…',
    filter_profile: 'Profil',
    filter_service: 'Usługa',
    clear_filters: 'Wyczyść filtry ×',
    assign_profile: 'Przypisz profil',
    detach_service: 'Wypisz z usługi',
    assign_service: 'Przypisz do usługi',
    assign_service_count: 'Przypisz do usługi ({{n}})',
    select_profile_for_service:
      'Wybierz profil dla {{n}} użytkowników przypisywanych do usługi.',
    toast_service_assigned: 'Przypisano {{n}} użytkowników do usługi.',
    toast_service_partial:
      'Przypisano do usługi {{ok}} użytkowników, {{failed}} nie powiodło się.',
    toast_service_failed:
      'Nie udało się przypisać {{n}} użytkowników do usługi.',
    toast_failure_reason: 'Powód: {{reason}}',
    ready_complete: 'Komplet',
    ready_missing: 'Brak',
    service_all: 'Wszyscy',
    service_assigned: 'Przypisani',
    service_unassigned: 'Nieprzypisani',
    profile_all: 'Wszystkie',
    no_parking_data: 'Brak danych parkingu',
    no_parking_data_desc:
      'Pool parkingowy nie jest skonfigurowany dla tej organizacji. Skontaktuj się z administratorem systemu, aby aktywować moduł.',
    toast_profile_assigned: 'Profil przypisany do {{n}} użytkowników.',
    toast_profile_partial:
      'Profil przypisano dla {{ok}} użytkowników, {{failed}} nie powiodło się.',
    toast_profile_failed:
      'Nie udało się przypisać profilu {{n}} użytkownikom.',
    toast_detached: 'Wypisano {{n}} użytkowników z usługi.',
    toast_detached_partial:
      'Wypisano {{ok}} użytkowników, {{failed}} nie powiodło się.',
    toast_detached_failed:
      'Nie udało się wypisać {{n}} użytkowników z usługi.',
    no_profiles_available: 'Brak dostępnych profili.',
    select_profile_for_users:
      'Wybierz profil dla {{n}} zaznaczonych użytkowników.',
    toast_generating_csv: 'Generowanie pliku CSV… plik zostanie pobrany.',
    csv_full_name: 'Imię i nazwisko',
    csv_login: 'Login',
    csv_work_email: 'E-mail służbowy',
    csv_profile: 'Profil',
    csv_service: 'Usługa',
  },
  hid: {
    hid_account: 'Konto mobilnej karty dostepowej',
    mobile_access_card: 'Mobilna karta dostępowa',
    create_hid_account: 'Utwórz konto HID',
    delete_hid_account: 'Usuń konto HID',
    true: 'Tak',
    false: 'Nie',
    active: 'Aktywna',
    inactive: 'Nieaktywna',
    account_created: 'Konto utworzone. Brak podpiętych kart.',
    card_number: 'Numer karty',
    privileges_requested: 'Oczekuje na uprawnienia',
    privileges_granted: 'Uprawnienia przyznane',
    access_granted: 'Dostęp przyznany',
    success_message: 'Konto zostało utworzone',
    delete_HID_account: 'Usuń konto HID',
    delete_HID_card: 'Usuń kartę HID',
    delete_card: 'Usuń kartę',
    delete_access_card: 'Usuń kartę dostępową',
    awaiting_installation: 'Oczekuje na instalację',
    invitation_code: 'Kod zaproszenia',
    device_id: 'ID urządzenia',
    mysolvy_ticket_id: 'ID zgłoszenia MySolvy',
    mysolvy_ticket_status: 'Status zgłoszenia',
    delete_HID_cards: 'Usuń wybrane karty',
    delete_account_confirmation:
      'Czy na pewno chcesz usunąć mobilne konto dostępowe uzytkownika ',
    delete_card_confirmation: 'Czy na pewno chcesz usunąć kartę o numerze ',
    delete_selected_cards_confirmation:
      'Czy na pewno chcesz usunąć karty wybranych użytkowników?',
    no_hid_account_assigned: 'Brak konfiguracji HID',
    no_hid_account_assigned_desc:
      'Moduł mobilnej karty dostępowej nie jest skonfigurowany dla tej organizacji. Skontaktuj się z administratorem systemu, aby aktywować usługę HID.',
    hid_account_deleted: 'Konto HID zostało usunięte',
    account_deletion_in_progress: 'Trwa usuwanie konta...',
    account_under_creation: 'Konto jest w trakcie tworzenia',
    card_data: 'Dane karty:',
    card_under_creation: 'Karta w trakcie tworzenia',
    card_under_creation_desc:
      'Trwa konfiguracja karty dostępowej. Może to chwilę potrwać — odśwież widok za kilka minut.',
    card_deletion_in_progress: 'Trwa usuwanie karty...',
    card_requested: 'Zlecenie utworzenia karty zostało wysłane',
    card_requested_desc:
      'Konto pojawi się po potwierdzeniu przez HID. Może to chwilę potrwać — odśwież widok za kilka minut.',
    device: 'Urządzenie',
    card_deleted: 'Karta została usunięta',
    create_card: 'Utwórz kartę',
    card_settings: 'Ustawienia karty',
    with_parking_access:
      'Zaznacz, jeśli użytkownik ma już aktywny dostęp do parkingu',
    max_number_of_mobile_cards: 'Maksymalna liczba kart',
    used_cards: 'Użyte karty',
    deletion_requirement:
      'Aby usunąć kartę wymagane jest ID urządzenia, odśwież lub poczekaj aż użytkownik otworzy aplikację.',
    no_card_created: 'Nie udało się utworzyć karty',
    no_card_created_desc:
      'Coś poszło nie tak podczas konfiguracji karty dostępowej. Spróbuj ponownie lub skontaktuj się z administratorem systemu, jeśli problem się powtarza.',
    no_device_warning:
      'Karta oczekuje na instalację w telefonie użytkownika. By ją zainstalować użytkownik musi uruchomić aplikację MyOlivia, kliknąć w kafel  „Karta dostępu” i postępować zgodnie z instrukcjami.',
    comment: 'Dodatkowe uwagi do zgłoszenia',
    add_attachment: 'Dodaj załącznik do zgłoszenia',
    deletion_comment: 'Opcjonalny komentarz do usunięcia karty',
    deletion_selected_cards_comment: 'Opcjonalny komentarz',
    mysolvy_task_link: 'Link do zgłoszenia w MySolvy',
    number_of_cards: 'Pula kart',
    active_cards: 'Karty aktywne',
    mobile_card_activity: 'Karta mobilna',
    card_status: 'Status karty',
    parking_access: 'Dostęp do parkingu',
    my_solvy_task_number: 'Numer zgłoszenia MySolvy',
    no_my_solvy_number:
      'Zgłoszenie w MySolvy zostanie utworzone po instalacji karty na telefonie użytkownika.',
    card_created: 'Utworzona karta',
    delete_cards_tip:
      'Wybierz z listy użytkowników posiadających aktywne karty',
  },
  hid_status: {
    NEW: 'Inicjacja karty',
    INVITATION_PENDING: 'Zaproszenie u użytkownika',
    INVITATION_ACKNOWLEDGED: 'Aktywacja karty',
    CREDENTIAL_ISSUE_INITIATED: 'Aktywacja karty',
    ENDPOINT_ACTIVE: 'Aktywacja karty',
    CREDENTIAL_ISSUING: 'Aktywacja karty',
    CREDENTIAL_ISSUED: 'Aktywacja dostępów na karcie',
    ACTIVE: 'Karta aktywna',
    CREDENTIAL_REVOKING: 'Usuwanie karty',
    CREDENTIAL_REVOKED: 'Karta usunięta',
    ENDPOINT_TERMINATED: 'Karta usunięta',
    ENDPOINT_DELETE_INITIATED: 'Karta usunięta',
    INVITATION_EXPIRED: 'Zaproszenie wygasło',
    INVITATION_CANCEL_INITIATED: 'Zaproszenie anulowane',
    INVITATION_CANCELLED: 'Zaproszenie anulowane',
    NEW_DESC: '???',
    INVITATION_PENDING_DESC:
      'Do użytkownika wysłano zaproszenie do instalacji mobilnej karty w telefonie. ',
    ACTIVE_DESC:
      'Karta została utworzona. Dostępy zostały nadane. Gotowa do użycia.',
    ENDPOINT_ACTIVE_DESC:
      'Użytkownik zaakceptował zaproszenie do instalacji mobilnej karty w telefonie. Proces aktywacji karty użytkownika został zainicjowany.',
    CREDENTIAL_ISSUED_DESC:
      'Dane karty zapisano w telefonie  użytkownika. Trwa aktywacja dostępów dla Użytkownika',
    CREDENTIAL_REVOKING_DESC:
      'Rozpoczęto proces usuwania karty mobilnej użytkownika.',
    CREDENTIAL_REVOKED_DESC:
      'Zakończono proces usuwania karty mobilnej użytkownika.',
    collapse: 'Zwiń legendę statusów',
    expand: 'Rozwiń legendę statusów',
  },
  hid_status_description: {
    NEW: '???',
    INVITATION_PENDING:
      'Do użytkownika wysłano zaproszenie do instalacji mobilnej karty w telefonie.',
    INVITATION_ACKNOWLEDGED:
      'Użytkownik zaakceptował zaproszenie do instalacji mobilnej karty w telefonie. Proces aktywacji karty użytkownika został zainicjowany.',
    CREDENTIAL_ISSUE_INITIATED:
      'Użytkownik zaakceptował zaproszenie do instalacji mobilnej karty w telefonie. Proces aktywacji karty użytkownika został zainicjowany.',
    ENDPOINT_ACTIVE:
      'Użytkownik zaakceptował zaproszenie do instalacji mobilnej karty w telefonie. Proces aktywacji karty użytkownika został zainicjowany.',
    CREDENTIAL_ISSUING:
      'Użytkownik zaakceptował zaproszenie do instalacji mobilnej karty w telefonie. Proces aktywacji karty użytkownika został zainicjowany.',
    CREDENTIAL_ISSUED:
      'Dane karty zapisano w telefonie  użytkownika. Trwa aktywacja dostępów dla Użytkownika',
    ACTIVE:
      'Karta została utworzona. Dostępy zostały nadane. Gotowa do użycia.',
    CREDENTIAL_REVOKING:
      'Rozpoczęto proces usuwania karty mobilnej użytkownika.',
    CREDENTIAL_REVOKED:
      'Zakończono proces usuwania karty mobilnej użytkownika.',
    ENDPOINT_TERMINATED:
      'Zakończono proces usuwania karty mobilnej użytkownika.',
    ENDPOINT_DELETE_INITIATED:
      'Zakończono proces usuwania karty mobilnej użytkownika.',
  },
  parking_pool: {
    assign_user: 'Przypisz użytkownika do usługi',
    assign_user_to_profile: 'Przypisz użytkownika do profilu',
    assigned_user: 'Użytkownik przypisany do usługi',
    unassigned_user: 'Użytkownik nieprzypisany do usługi',
    no_car_plate_assigned_info:
      'Aby przypisać tablice rejestracyjne dodaj kartę dostępową',
    no_card_assigned_info:
      'Aby aktywować możliwość rezerwacji parkingu przez użytkownika dodaj kartę dostępową oraz tablicę rejestracyjną',
    edit_car_plates: 'Edytuj tablice rejestracyjne',
    unassign_user: 'Wypisz użytkownika z usługi',
    assigned_users: 'Przypisani do usługi',
    no_users: 'Brak użytkowników',
    assign_profile_info:
      'Aby wybrać profil, należy najpierw przypisać użytkownika do usługi.',
    profile: 'Profil usługi',
    choose_profile: 'Wybierz profil',
    no_profile: 'Brak profilu',
    assign_error: 'Wystąpił błąd przypisania użytkownika',
    unassign_error: 'Wystąpił błąd wypisania użytkownika z usługi',
    assign_profile_error: 'Wystąpił błąd przypisania profilu',
    unassign_profile_error: 'Wystąpił błąd usunięcia profilu',
    unassign_modal_title: 'Wypisać użytkownika z usługi?',
    unassign_modal_lead:
      'Użytkownik zostanie usunięty z tej usługi i nie będzie mógł rezerwować w niej miejsc. Jego dane i tablice rejestracyjne zostaną zachowane, a użytkownika możesz przypisać ponownie w dowolnym momencie.',
    unassign_active_reservation:
      'Użytkownik ma aktywną rezerwację parkingową. Wypisanie z usługi jej nie anuluje — jeśli ma przepaść, anuluj ją wcześniej w zakładce Rezerwacje.',
    unassign_with_card: 'Usuń jednocześnie kartę dostępową',
    unassign_title:
      'Wybierz opcję usunięcia karty, aby odebrać ją użytkownikowi.',
    unassign_card_warning:
      'Jeśli użytkownik straci dostęp do karty, nie będzie mógł z niej korzystać w ramach aktualnego abonamentu parkingowego.',
    assigned_service_badge: 'Przypisany do usługi',
    unassigned_service_badge: 'Nieprzypisany do usługi',
    assign_user_short: 'Przypisz',
    unassign_user_short: 'Wypisz',
    assign_to_service: 'Przypisz do usługi',
    assign_ready: 'Wszystkie kroki gotowe — możesz przypisać użytkownika.',
    assign_prerequisites:
      'Dodaj kartę dostępową i tablicę rejestracyjną, aby przypisać użytkownika do usługi.',
    select_profile_to_assign:
      'Wybierz profil, aby przypisać użytkownika do usługi.',
    no_profiles_available:
      'Utwórz profil w puli, aby móc przypisać użytkownika do usługi.',
  },
}

export default pl
